import React, { useState } from 'react';
import { Element } from 'react-scroll';
import me from './me.jpg';
import './LandingPage.css'
import usecase from './software/usecase.png';
import description1 from './software/description1.png';
import description2 from './software/description2.png';
import communication1 from './software/communication1.png';
import communication2 from './software/communication2.png';
import communication3 from './software/communication3.png';
import communication4 from './software/communication4.png';
import communication5 from './software/communication5.png';
import communication6 from './software/communication6.png';
import class1 from './software/class1.png';
import class2 from './software/class2.png';
import class3 from './software/class3.png';
import class4 from './software/class4.png';
import class5 from './software/class5.png';
import program from './software/program.png';
import bluechip1 from './bluechip/bluechip1.jpg';
import bluechip2 from './bluechip/bluechip2.jpg';
import bluechip3 from './bluechip/bluechip3.jpg';
import bluechip4 from './bluechip/bluechip4.jpg';
import bluechip5 from './bluechip/bluechip5.jpg';
import bluechip6 from './bluechip/bluechip6.jpg';
import bluechip7 from './bluechip/bluechip7.jpg';
import bluechip8 from './bluechip/bluechip8.jpg';
import bluechip9 from './bluechip/bluechip9.jpg';
import bluechip10 from './bluechip/bluechip10.jpg';
import bluechip11 from './bluechip/bluechip11.jpg';
import bluechip12 from './bluechip/bluechip12.jpg';
import bluechip13 from './bluechip/bluechip13.jpg';
import bluechip14 from './bluechip/bluechip14.jpg';
import bluechip15 from './bluechip/bluechip15.jpg';
import bluechip16 from './bluechip/bluechip16.jpg';
import bluechip17 from './bluechip/bluechip17.jpg';
import bluechip18 from './bluechip/bluechip18.jpg';
import bluechip19 from './bluechip/bluechip19.jpg';
import bluechip20 from './bluechip/bluechip20.jpg';
import bluechip21 from './bluechip/bluechip21.jpg';
import bluechip22 from './bluechip/bluechip22.jpg';
import bluechip23 from './bluechip/bluechip23.jpg';
import bluechip24 from './bluechip/bluechip24.jpg';
import bluechip25 from './bluechip/bluechip25.jpg';
import bluechip26 from './bluechip/bluechip26.jpg';
import bluechip27 from './bluechip/bluechip27.jpg';
import hiarc1 from './hiarc/hiarc1.jpg';
import hiarc2 from './hiarc/hiarc2.jpg';
import hiarc3 from './hiarc/hiarc3.jpg';
import hiarc4 from './hiarc/hiarc4.jpg';
import hiarc5 from './hiarc/hiarc5.jpg';
import hiarc6 from './hiarc/hiarc6.jpg';
import hiarc7 from './hiarc/hiarc7.jpg';

function LandingPage() {
    const [showProjectDetails1, setShowProjectDetails1] = useState(false);
    const [showProjectDetails2, setShowProjectDetails2] = useState(false);
    const [showProjectDetails3, setShowProjectDetails3] = useState(false);
    const [showProjectDetails4, setShowProjectDetails4] = useState(false);
    const [showProjectDetails5, setShowProjectDetails5] = useState(false);
    const [showActivityDetails1, setShowActivityDetails1] = useState(false);
    const [showActivityDetails2, setShowActivityDetails2] = useState(false);
    const [showActivityDetails3, setShowActivityDetails3] = useState(false);
    const [showAwardDetails1, setShowAwardDetails1] = useState(false);
    const [showAwardDetails2, setShowAwardDetails2] = useState(false);
    const [showIntroduce1, setShowIntoduce1] = useState(true);
    const [showIntroduce2, setShowIntoduce2] = useState(false);
    const [showIntroduce3, setShowIntoduce3] = useState(false);
    const [showUsecaseDescription, setShowUsecaseDescription] = useState(true);
    const [showUsecaseDiagram, setShowUsecaseDiagram] = useState(false);
    const [showCommunicationDiagram, setShowCommunicationDiagram] = useState(false);
    const [showClassDiagram, setShowClassDiagram] = useState(false);
    const [showSystem, setShowSystem] = useState(false);
    const [showBluechip1, setShowBluechip1] = useState(true);
    const [showBluechip2, setShowBluechip2] = useState(false);
    const [showBluechip3, setShowBluechip3] = useState(false);
    const [showHiarc1, setShowHiarc1] = useState(true);
    const [showHiarc2, setShowHiarc2] = useState(false);
    const [showHiarc3, setShowHiarc3] = useState(false);
    const [showHiarc4, setShowHiarc4] = useState(false);
    const [showHiarc5, setShowHiarc5] = useState(false);

    const communicationImages = [communication1, communication2, communication3, communication4, communication5, communication6];
    const [currentImageIndex1, setCurrentImageIndex1] = useState(0);

    const nextImage1 = () => {
        if (currentImageIndex1 < communicationImages.length - 1) {
            setCurrentImageIndex1(currentImageIndex1 + 1);
        }
    };

    const prevImage1 = () => {
        if (currentImageIndex1 > 0) {
            setCurrentImageIndex1(currentImageIndex1 - 1);
        }
    };

    const classImages = [class1, class2, class3, class4, class5];
    const [currentImageIndex2, setCurrentImageIndex2] = useState(0);

    const nextImage2 = () => {
        if (currentImageIndex2 < classImages.length - 1) {
            setCurrentImageIndex2(currentImageIndex2 + 1);
        }
    };

    const prevImage2 = () => {
        if (currentImageIndex2 > 0) {
            setCurrentImageIndex2(currentImageIndex2 - 1);
        }
    };

    const bluechipImages = [bluechip2, bluechip3, bluechip4, bluechip5, bluechip6, bluechip7, bluechip8, bluechip9, bluechip10, bluechip11, bluechip12, bluechip13, bluechip14, bluechip15, bluechip16, bluechip17, bluechip18, bluechip19, bluechip20, bluechip21, bluechip22, bluechip23];
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const nextImage = () => {
        if (currentImageIndex < bluechipImages.length - 1) {
            setCurrentImageIndex(currentImageIndex + 1);
        }
    };

    const prevImage = () => {
        if (currentImageIndex > 0) {
            setCurrentImageIndex(currentImageIndex - 1);
        }
    };

    const toggleProjectDetails1 = () => {
        setShowProjectDetails1(!showProjectDetails1);
    };

    const toggleProjectDetails2 = () => {
        setShowProjectDetails2(!showProjectDetails2);
    };

    const toggleProjectDetails3 = () => {
        setShowProjectDetails3(!showProjectDetails3);
    };

    const toggleProjectDetails4 = () => {
        setShowProjectDetails4(!showProjectDetails4);
    };

    const toggleProjectDetails5 = () => {
        setShowProjectDetails5(!showProjectDetails5);
    };

    const toggleActivityDetails1 = () => {
        setShowActivityDetails1(!showActivityDetails1);
    };

    const toggleActivityDetails2 = () => {
        setShowActivityDetails2(!showActivityDetails2);
    };

    const toggleActivityDetails3 = () => {
        setShowActivityDetails3(!showActivityDetails3);
    };

    const toggleAwardDetails1 = () => {
        setShowAwardDetails1(!showAwardDetails1);
    };

    const toggleAwardDetails2 = () => {
        setShowAwardDetails2(!showAwardDetails2);
    };

    return (
        <div style={{ paddingLeft : '15%', paddingRight : '15%', fontFamily: 'JalnanGothic' }}>
            <Element name="about"></Element>
            <div style={{ paddingTop: '120px' }}></div>
            <div className="card-face">
                <strong style={{ fontSize: '48px', marginLeft: '30px' }}>About</strong>
                <br />
                <div>
                    <div className="img-container">
                        <img src={me} alt="Me" />
                    </div>
                    <div style={{ paddingTop: '20px' }}>
                        <div style={{ paddingTop: '20px', display:'flex', flexDirection: 'row' }}>
                            <div style={{ fontSize: '13px' }}>
                                🔘 &nbsp;
                            </div>
                            <div style={{ fontSize: '20px' }}>
                                백앤드 개발자를 꿈꾸는 이윤식입니다.
                            </div>
                        </div>
                        <div style={{ paddingTop: '20px', display:'flex', flexDirection: 'row' }}>
                            <div style={{ fontSize: '13px' }}>
                                🔘 &nbsp;
                            </div>
                            <div style={{ fontSize: '20px' }}>
                                고객이 만족하는 서비스를 설계 및 개발하고 비즈니스 성과를 창출하는 것에 관심이 있습니다.
                            </div>
                        </div>
                        <div style={{ paddingTop: '20px', display:'flex', flexDirection: 'row' }}>
                            <div style={{ fontSize: '13px' }}>
                                🔘 &nbsp;
                            </div>
                            <div style={{ fontSize: '20px' }}>
                                두 번의 풀스택 개발 경험을 통해 프론트앤드 개발자와 원활한 소통이 가능합니다.
                            </div>
                        </div>
                        <div style={{ paddingTop: '20px', display:'flex', flexDirection: 'row' }}>
                            <div style={{ fontSize: '13px' }}>
                                🔘 &nbsp;
                            </div>
                            <div style={{ fontSize: '20px' }}>
                                어려운 문제를 동료들과 함께 해결해 나가는 것을 좋아합니다.
                            </div>
                        </div>
                        <div style={{ paddingTop: '20px', display:'flex', flexDirection: 'row' }}>
                            <div style={{ fontSize: '13px' }}>
                                🔘 &nbsp;
                            </div>
                            <div style={{ fontSize: '20px' }}>
                                 도전정신과 끊임없는 학습을 바탕으로 매일매일 성장하고 있습니다.
                            </div>
                        </div>
                        <div style={{ paddingTop: '20px', display:'flex', flexDirection: 'row' }}>
                            <div style={{ fontSize: '13px' }}>
                                🔘 &nbsp;
                            </div>
                            <div style={{ fontSize: '20px' }}> GitHub : &nbsp;
                                <a href="https://github.com/rilato">https://github.com/rilato</a>
                            </div>
                        </div>
                        <div style={{ paddingTop: '20px', display:'flex', flexDirection: 'row' }}>
                            <div style={{ fontSize: '13px' }}>
                                🔘 &nbsp;
                            </div>
                            <div style={{ fontSize: '20px' }}> Baekjoon : &nbsp;
                                <a href="https://www.acmicpc.net/user/croco1997">https://www.acmicpc.net/user/croco1997</a>
                            </div>
                        </div>
                        <div style={{ paddingTop: '20px', display:'flex', flexDirection: 'row' }}>
                            <div style={{ fontSize: '13px' }}>
                                🔘 &nbsp;
                            </div>
                            <div style={{ fontSize: '20px' }}> Solved.ac : &nbsp;
                                <a href="https://solved.ac/profile/croco1997">https://solved.ac/profile/croco1997</a>
                            </div>
                        </div>
                        <div style={{ paddingTop: '30px' }}></div>
                        <div className="card-card-face">
                            <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', paddingBottom: '30px' }}>
                                <button className="land-button" onClick={() => { setShowIntoduce1(true); setShowIntoduce2(false); setShowIntoduce3(false); }}>언어</button>
                                <button className="land-button" onClick={() => { setShowIntoduce1(false); setShowIntoduce2(true); setShowIntoduce3(false); }}>기술 스택</button>
                                <button className="land-button" onClick={() => { setShowIntoduce1(false); setShowIntoduce2(false); setShowIntoduce3(true); }}>자격증</button>
                            </div>
                            {showIntroduce1 && (
                                <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '15px' }}>
                                    <div style={{ fontSize: '17px', marginBottom: '15px' }}>
                                        - Java
                                    </div>
                                    <div style={{ fontSize: '17px', marginBottom: '15px' }}>
                                        - C++
                                    </div>
                                    <div style={{ fontSize: '17px', marginBottom: '15px' }}>
                                        - C
                                    </div>
                                    <div style={{ fontSize: '17px', marginBottom: '15px' }}>
                                        - Python
                                    </div>
                                    <div style={{ fontSize: '17px', marginBottom: '15px' }}>
                                        - JavaScript
                                    </div>
                                    <div style={{ fontSize: '17px', marginBottom: '15px' }}>
                                        - C#
                                    </div>
                                    <div style={{ fontSize: '17px', marginBottom: '15px' }}>
                                        etc : Lisp, Lex, Yacc, Prolog
                                    </div>
                                </div>
                            )}
                            {showIntroduce2 && (
                                <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '15px' }}>
                                    <div style={{ fontSize: '16px', marginBottom: '10px', display:'flex', flexDirection: 'row' }}>
                                        <div style={{ fontSize: '11px' }}>
                                            🔘 &nbsp;
                                        </div>
                                        <div style={{ fontSize: '17px' }}>
                                            BackEnd
                                        </div>
                                    </div>
                                    <div style={{ fontSize: '16px', marginBottom: '20px', paddingLeft: '15px' }}>
                                        Spring Boot, Spring, Spring Security, Spring Data JPA, Hibernate, QueryDSL, Node.JS, Gradle, Maven, Jsoup
                                    </div>
                                    <div style={{ fontSize: '16px', marginBottom: '10px', display:'flex', flexDirection: 'row' }}>
                                        <div style={{ fontSize: '11px' }}>
                                            🔘 &nbsp;
                                        </div>
                                        <div style={{ fontSize: '17px' }}>
                                            Database
                                        </div>
                                    </div>
                                    <div style={{ fontSize: '16px', marginBottom: '20px', paddingLeft: '15px' }}>
                                        PostgreSQL, MongoDB, Redis
                                    </div>
                                    <div style={{ fontSize: '16px', marginBottom: '10px', display:'flex', flexDirection: 'row' }}>
                                        <div style={{ fontSize: '11px' }}>
                                            🔘 &nbsp;
                                        </div>
                                        <div style={{ fontSize: '17px' }}>
                                            FrontEnd
                                        </div>
                                    </div>
                                    <div style={{ fontSize: '16px', marginBottom: '20px', paddingLeft: '15px' }}>
                                        React, Redux, Antd, Bootstrap, HTML, CSS
                                    </div>
                                    <div style={{ fontSize: '16px', marginBottom: '10px', display:'flex', flexDirection: 'row' }}>
                                        <div style={{ fontSize: '11px' }}>
                                            🔘 &nbsp;
                                        </div>
                                        <div style={{ fontSize: '17px' }}>
                                            etc
                                        </div>
                                    </div>
                                    <div style={{ fontSize: '16px', marginBottom: '20px', paddingLeft: '15px' }}>
                                        Docker, Google Cloud Storage, Git, Github
                                    </div>
                                </div>
                            )}
                            {showIntroduce3 && (
                                <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '15px' }}>
                                    <div style={{ fontSize: '17px', marginBottom: '15px' }}>
                                        - Toeic Speaking (AL, 160점)
                                    </div>
                                    <div style={{ fontSize: '17px', marginBottom: '15px' }}>
                                        - 정보처리기사
                                    </div>
                                    <div style={{ fontSize: '17px', marginBottom: '15px' }}>
                                        - 컴퓨터활용능력1급
                                    </div>
                                    <div style={{ fontSize: '17px', marginBottom: '15px' }}>
                                        - 한국사능력검정시험1급
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Element name="education"></Element>
            <div style={{ paddingTop: '120px' }}></div>
            <div className="card-face">
                <strong style={{ fontSize: '48px', marginLeft: '30px' }}>Education</strong>
                <div style={{ paddingTop: '50px', display:'flex', flexDirection: 'row' }}>
                    <div style={{ fontSize: '16px' }}>
                        🔘 &nbsp;
                    </div>
                    <div style={{ fontSize: '24px' }}>
                        청원고등학교 인문계 (2013.03 ~ 2016.02)
                    </div>
                </div>
                <div style={{ paddingTop: '20px', display:'flex', flexDirection: 'row' }}>
                    <div style={{ fontSize: '16px' }}>
                        🔘 &nbsp;
                    </div>
                    <div style={{ fontSize: '24px' }}>
                        홍익대학교 경영대학 경영학부 경영학전공 경영학사 (2017.03 ~ 2024.02, 주전공)
                    </div>
                </div>
                <div style={{ marginLeft : '30px', paddingTop: '10px', paddingBottom: '10px', fontSize: '20px' }}>
                    - 전체 평점 : 4.12 / 4.50
                    <br/>
                    - 전공 평점 : 4.23 / 4.50
                </div>
                <div style={{ paddingTop: '20px', display:'flex', flexDirection: 'row' }}>
                    <div style={{ fontSize: '16px' }}>
                        🔘 &nbsp;
                    </div>
                    <div style={{ fontSize: '24px' }}>
                        홍익대학교 공과대학 정보컴퓨터공학부 컴퓨터공학전공 공학사 (2017.03 ~ 2024.02, 복수전공)
                    </div>
                </div>
                <div style={{ marginLeft : '30px', paddingTop: '10px', paddingBottom: '10px', fontSize: '20px' }}>
                    - 전체 평점 : 4.12 / 4.50
                    <br/>
                    - 전공 평점 : 4.21 / 4.50
                </div>
            </div>
            <Element name="project"></Element>
            <div style={{ paddingTop: '120px' }}></div>
            <div className="card-face">
                <strong style={{ fontSize: '48px', marginLeft: '30px' }}>Project</strong>
                <div onClick={toggleProjectDetails1} style={{ cursor: 'pointer', paddingTop: '50px', fontSize: '20px' }}>
                    <div style={{ display:'flex', flexDirection: 'row', marginBottom: '20px' }}>
                        <div style={{ fontSize: '18px' }}>
                            🔘 &nbsp;
                        </div>
                        <div style={{ fontSize: '27px' }}>
                            P!ck Me (2023.03 ~ 2023.12)
                        </div>
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 주제 : 포트폴리오 기반 팀 빌딩 웹 서비스
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 역할 : 팀장 및 풀스택 개발자로 참여하여 기획, 설계, 개발
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 스택 : SpringBoot, React, Redux, PostgreSQL, Gradle, Redis, Spring Data JPA, Query DSL, Hibernate, Google Cloud Storage
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 자세히 보기 / 닫기 (클릭)
                    </div>
                </div>
                {showProjectDetails1 && (
                    <div style={{ marginLeft: '50px', paddingTop: '30px', marginBottom: '20px' }}>
                        <div style={{ fontSize: '20px', marginBottom: '20px' }}> - GitHub : &nbsp;
                            <a href="https://github.com/rilato/PickMe">https://github.com/rilato/PickMe</a>
                        </div>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/2pCKwlUozqg" frameborder="0" allowfullscreen></iframe>
                    </div>
                )}
                <div onClick={toggleProjectDetails2} style={{ cursor: 'pointer', paddingTop: '20px', fontSize: '20px' }}>
                    <div style={{ display:'flex', flexDirection: 'row', marginBottom: '20px' }}>
                        <div style={{ fontSize: '18px' }}>
                            🔘 &nbsp;
                        </div>
                        <div style={{ fontSize: '27px' }}>
                            맛있홍 (2023.03 ~ 2023.12)
                        </div>
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 주제 : 맛집 리뷰 웹 서비스
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 역할 : 팀장 및 풀스택 개발자로 참여하여 기획, 설계, 개발
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 스택 : Node.js, React, Redux, MongoDB, Node Mailer, JWT, Kakao Map API
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 자세히 보기 / 닫기 (클릭)
                    </div>
                </div>
                {showProjectDetails2 && (
                    <div style={{ marginLeft: '50px', paddingTop: '30px', marginBottom: '20px' }}>
                        <div style={{ fontSize: '20px', marginBottom: '20px' }}> - GitHub : &nbsp;
                            <a href="https://github.com/rilato/Masithong">https://github.com/rilato/Masithong</a>
                        </div>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/B43rknPcIGk" frameborder="0" allowfullscreen></iframe>
                    </div>
                )}
                <div onClick={toggleProjectDetails3} style={{ cursor: 'pointer', paddingTop: '20px', fontSize: '20px' }}>
                    <div style={{ display:'flex', flexDirection: 'row', marginBottom: '20px' }}>
                        <div style={{ fontSize: '18px' }}>
                            🔘 &nbsp;
                        </div>
                        <div style={{ fontSize: '27px' }}>
                            채용 관리 시스템 (2023.03 ~ 2023.06)
                        </div>
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 주제 : 채용 관리 시스템
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 역할 : 팀장으로 참여하여, 고객의 요구사항에 맞게 채용 관리 시스템 설계 및 개발
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 스택 : UML (Usecase Diagram, Communication Diagram, Class Diagram), C++
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 자세히 보기 / 닫기 (클릭)
                    </div>
                </div>
                {showProjectDetails3 && (
                    <div style={{ marginLeft: '50px', paddingTop: '30px', marginBottom: '20px' }}>
                        <div style={{ fontSize: '20px', marginBottom: '20px' }}> - GitHub : &nbsp;
                            <a href="https://github.com/rilato/Software_Engineering">https://github.com/rilato/Software_Engineering</a>
                        </div>
                        <div style={{ fontSize: '20px', marginBottom: '20px' }}> - 다이어그램 그리고 시스템 설계하기
                        </div>
                        <div className="card-card-face">
                            <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', paddingBottom: '10px' }}>
                                <button className="land-button" onClick={() => { setShowUsecaseDescription(true); setShowUsecaseDiagram(false); setShowCommunicationDiagram(false); setShowClassDiagram(false); setShowSystem(false); }}>Description</button>
                                <button className="land-button" onClick={() => { setShowUsecaseDescription(false); setShowUsecaseDiagram(true); setShowCommunicationDiagram(false); setShowClassDiagram(false); setShowSystem(false); }}>Usecase</button>
                                <button className="land-button" onClick={() => { setShowUsecaseDescription(false); setShowUsecaseDiagram(false); setShowCommunicationDiagram(true); setShowClassDiagram(false); setShowSystem(false); }}>Communication</button>
                                <button className="land-button" onClick={() => { setShowUsecaseDescription(false); setShowUsecaseDiagram(false); setShowCommunicationDiagram(false); setShowClassDiagram(true); setShowSystem(false); }}>Class</button>
                                <button className="land-button" onClick={() => { setShowUsecaseDescription(false); setShowUsecaseDiagram(false); setShowCommunicationDiagram(false); setShowClassDiagram(false); setShowSystem(true); }}>System</button>
                            </div>
                            {showUsecaseDescription && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <img src={description1} alt="description1" style={{ width: '48%', height: '100%' }} />
                                    <img src={description2} alt="description2" style={{ width: '48%', height: '100%' }} />
                                </div>
                            )}
                            {showUsecaseDiagram && (
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img src={usecase} alt="usecase" style={{ width: '48%', height: '100%' }} />
                                </div>
                            )}
                            {showCommunicationDiagram && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div>
                                        <button style={{ width: '100px', height: '50px', fontWeight: 'bold', backgroundColor: '#B3D6C6', borderRadius: '5px', border: '1px solid #B3D6C6', cursor: 'pointer' }} onClick={prevImage1} disabled={currentImageIndex1 === 0}>이전</button>
                                    </div>
                                    <div style={{ marginLeft: '20px', marginRight: '20px' }}>
                                        <img src={communicationImages[currentImageIndex1]} alt="communication" style={{ width: '670px', height: '1280px' }} />
                                    </div>
                                    <div>
                                        <button style={{ width: '100px', height: '50px', fontWeight: 'bold', backgroundColor: '#B3D6C6', borderRadius: '5px', border: '1px solid #B3D6C6', cursor: 'pointer' }} onClick={nextImage1} disabled={currentImageIndex1 === communicationImages.length - 1}>다음</button>
                                    </div>
                                </div>
                            )}
                            {showClassDiagram && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div>
                                        <button style={{ width: '100px', height: '50px', fontWeight: 'bold', backgroundColor: '#B3D6C6', borderRadius: '5px', border: '1px solid #B3D6C6', cursor: 'pointer' }} onClick={prevImage2} disabled={currentImageIndex2 === 0}>이전</button>
                                    </div>
                                    <div style={{ marginLeft: '20px', marginRight: '20px' }}>
                                        <img src={classImages[currentImageIndex2]} alt="class" style={{ width: '670px', height: '1280px' }} />
                                    </div>
                                    <div>
                                        <button style={{ width: '100px', height: '50px', fontWeight: 'bold', backgroundColor: '#B3D6C6', borderRadius: '5px', border: '1px solid #B3D6C6', cursor: 'pointer' }} onClick={nextImage2} disabled={currentImageIndex2 === classImages.length - 1}>다음</button>
                                    </div>
                                </div>
                            )}
                            {showSystem && (
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                    <div style={{ fontSize: '20px', marginBottom: '20px' }}>
                                        - 코드가 너무 길어 파일 이름들로 대체했습니다. 자세한 코드는 깃허브를 확인해주세요!
                                    </div>
                                    <div>
                                        <img src={program} alt="program" style={{ width: '800px', height: '1280px' }} />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                <div onClick={toggleProjectDetails4} style={{ cursor: 'pointer', paddingTop: '20px', fontSize: '20px' }}>
                    <div style={{ display:'flex', flexDirection: 'row', marginBottom: '20px' }}>
                        <div style={{ fontSize: '18px' }}>
                            🔘 &nbsp;
                        </div>
                        <div style={{ fontSize: '27px' }}>
                            쳐라쳐라 매우쳐라 (2022.03 ~ 2022.06)
                        </div>
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 주제 : 격투 게임
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 역할 : 게임 개발 팀으로 참여하여 요구 사항에 맞는 게임 개발 및 배포
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 스택 : C#, Unity
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 자세히 보기 / 닫기 (클릭)
                    </div>
                </div>
                {showProjectDetails4 && (
                    <div style={{ marginLeft: '50px', paddingTop: '30px', marginBottom: '20px' }}>
                        <strong style={{ fontSize: '20px' }}>플레이하기 : &nbsp;
                            <a href="https://play.google.com/store/apps/details?id=com.ExPStudio.HitItHitIt" target="_blank" rel="noopener noreferrer">
                                https://play.google.com/store/apps/details?id=com.ExPStudio.HitItHitIt
                            </a>
                        </strong>
                        <div style={{ paddingTop: '20px' }}></div>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/O8PyJGZpcdk" frameborder="0" allowfullscreen></iframe>
                    </div>
                )}
                <div onClick={toggleProjectDetails5} style={{ cursor: 'pointer', paddingTop: '20px', fontSize: '20px' }}>
                    <div style={{ display:'flex', flexDirection: 'row', marginBottom: '20px' }}>
                        <div style={{ fontSize: '18px' }}>
                            🔘 &nbsp;
                        </div>
                        <div style={{ fontSize: '27px' }}>
                            3Cards (2022.09 ~ 2022.12)
                        </div>
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 주제 : 카드 전략 게임
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 역할 : 기획 팀으로 참여하여 게임 기획 및 배포
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 스택 : C#, Unity
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 자세히 보기 / 닫기 (클릭)
                    </div>
                </div>
                {showProjectDetails5 && (
                    <div style={{ marginLeft: '50px', paddingTop: '30px', marginBottom: '20px' }}>
                        <strong style={{ fontSize: '20px' }}>플레이하기 : &nbsp;
                            <a href="https://play.google.com/store/apps/details?id=com.ExPstudio.threeCards&hl=ko&gl=US" target="_blank" rel="noopener noreferrer">
                                https://play.google.com/store/apps/details?id=com.ExPstudio.threeCards&hl=ko&gl=US
                            </a>
                        </strong>
                        <div style={{ paddingTop: '20px' }}></div>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/CNbowAN7FhE" frameborder="0" allowfullscreen></iframe>
                    </div>
                )}
            </div>
            <Element name="activity"></Element>
            <div style={{ paddingTop: '120px' }}></div>
            <div className="card-face">
                <strong style={{ fontSize: '48px', marginLeft: '30px' }}>Activity</strong>
                <div onClick={toggleActivityDetails1} style={{ cursor: 'pointer', paddingTop: '50px', fontSize: '20px' }}>
                    <div style={{ display:'flex', flexDirection: 'row', marginBottom: '20px' }}>
                        <div style={{ fontSize: '18px' }}>
                            🔘 &nbsp;
                        </div>
                        <div style={{ fontSize: '27px' }}>
                            블루칩 (2017.03 ~ 2017.12)
                        </div>
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 활동 내용 : 경영 및 경제 관련 세미나 참석 (우수 발표 팀으로 선정)
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 활동 내용 : 시각 디자인과 소모임 하이픈과 창업 경진 대회 참가
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 자세히 보기 / 닫기 (클릭)
                    </div>
                </div>
                {showActivityDetails1 && (
                    <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                        <div style={{ marginLeft: '50px' }} className="card-card-face">
                            <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', paddingBottom: '30px' }}>
                                <button className="land-button" onClick={() => { setShowBluechip1(true); setShowBluechip2(false); setShowBluechip3(false); }}>경영 경제 세미나</button>
                                <button className="land-button" onClick={() => { setShowBluechip1(false); setShowBluechip2(true); setShowBluechip3(false); }}>발표 자료</button>
                                <button className="land-button" onClick={() => { setShowBluechip1(false); setShowBluechip2(false); setShowBluechip3(true); }}>창업 경진 대회</button>
                            </div>
                            {showBluechip1 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                        <div style={{ fontSize: '20px', marginBottom: '20px' }}>
                                            - 마케팅의 불확실성과 대응전략에 대해 발표하여 우수 발표 팀으로 선정 (발표자 : 이윤식) 
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <img src={bluechip1} alt="bluechip1" style={{ width: '28%', height: '50%' }} />
                                            <img src={bluechip24} alt="bluechip24" style={{ width: '68%', height: '50%' }} />
                                        </div>
                                    </div>
                                </div>
                            )}
                            {showBluechip2 && (
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                        <div style={{ fontSize: '20px', marginBottom: '20px' }}>
                                            - 마케팅의 불확실성과 대응전략 PPT
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <div>
                                                <button style={{ width: '100px', height: '50px', fontWeight: 'bold', backgroundColor: '#B3D6C6', borderRadius: '5px', border: '1px solid #B3D6C6', cursor: 'pointer' }} onClick={prevImage} disabled={currentImageIndex === 0}>이전</button>
                                            </div>
                                            <div style={{ marginLeft: '20px', marginRight: '20px' }}>
                                                <img src={bluechipImages[currentImageIndex]} alt="Bluechip" style={{ width: '100%' }} />
                                            </div>
                                            <div>
                                                <button style={{ width: '100px', height: '50px', fontWeight: 'bold', backgroundColor: '#B3D6C6', borderRadius: '5px', border: '1px solid #B3D6C6', cursor: 'pointer' }} onClick={nextImage} disabled={currentImageIndex === bluechipImages.length - 1}>다음</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {showBluechip3 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                        <div style={{ fontSize: '20px', marginBottom: '20px' }}>
                                            - 창업 경진 대회 준비 및 참가
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <img src={bluechip25} alt="bluechip25" style={{ width: '30%', height: '50%', alignItems: 'center' }} />
                                            <img src={bluechip26} alt="bluechip26" style={{ width: '30%', height: '50%', alignItems: 'center' }} />
                                            <img src={bluechip27} alt="bluechip27" style={{ width: '29%', height: '50%', alignItems: 'center' }} />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                <div onClick={toggleActivityDetails2} style={{ cursor: 'pointer', paddingTop: '20px', fontSize: '20px' }}>
                    <div style={{ display:'flex', flexDirection: 'row', marginBottom: '20px' }}>
                        <div style={{ fontSize: '18px' }}>
                            🔘 &nbsp;
                        </div>
                        <div style={{ fontSize: '27px' }}>
                            Hi-Arc (2022.03 ~ 2022.12)
                        </div>
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 활동 내용 : 알고리즘 학회에서 조장으로 활동하며, 같은 조 후배들에게 알고리즘 문제 풀이 방법 전수
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 스택 : C, C++, Python
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 자세히 보기 / 닫기 (클릭)
                    </div>
                </div>
                {showActivityDetails2 && (
                    <div style={{ marginLeft: '50px', paddingTop: '10px', paddingBottom: '30px' }}>
                        <div style={{ fontSize: '20px', paddingBottom: '15px' }}> - 조 이름 : Next Level </div>
                        <div style={{ fontSize: '20px', paddingBottom: '15px' }}> - 시간 계획 : 수요일 6시 ~ 8시 </div>
                        <div style={{ fontSize: '20px', paddingBottom: '15px' }}> - 장소 계획 : 홍익대학교 카페나무 or A동 카페 </div>
                        <div style={{ fontSize: '20px', paddingBottom: '15px' }}> - 조장 : 이윤식 </div>
                        <div style={{ fontSize: '20px', paddingBottom: '15px' }}> - 조원들과의 한학기 목표 : 기초 언어 문법 습득, 알고리즘 문제 풀이 방법 습득 </div>
                        <div style={{ paddingTop: '15px' }}></div>
                        <div style={{ fontSize: '20px', paddingBottom: '15px' }}> - 활동 기록 </div>
                        <div className="card-card-face">
                            <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', paddingBottom: '30px' }}>
                                <button className="land-button" onClick={() => { setShowHiarc1(true); setShowHiarc2(false); setShowHiarc3(false); setShowHiarc4(false); setShowHiarc5(false); }}>2022.03.30</button>
                                <button className="land-button" onClick={() => { setShowHiarc1(false); setShowHiarc2(true); setShowHiarc3(false); setShowHiarc4(false); setShowHiarc5(false); }}>2022.04.06</button>
                                <button className="land-button" onClick={() => { setShowHiarc1(false); setShowHiarc2(false); setShowHiarc3(true); setShowHiarc4(false); setShowHiarc5(false); }}>2022.05.04</button>
                                <button className="land-button" onClick={() => { setShowHiarc1(false); setShowHiarc2(false); setShowHiarc3(false); setShowHiarc4(true); setShowHiarc5(false); }}>2022.05.11</button>
                                <button className="land-button" onClick={() => { setShowHiarc1(false); setShowHiarc2(false); setShowHiarc3(false); setShowHiarc4(false); setShowHiarc5(true); }}>2022.05.18</button>
                            </div>
                            {showHiarc1 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <img src={hiarc1} alt="hiarc1" style={{ width: '48%', height: '36%', marginLeft : '5px' }} />
                                    <img src={hiarc2} alt="hiarc2" style={{ width: '48%', height: '36%', marginRight : '5px' }} />
                                </div>
                            )}
                            {showHiarc2 && (
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img src={hiarc3} alt="hiarc3" style={{ width: '48%', height: '36%' }} />
                                </div>
                            )}
                            {showHiarc3 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <img src={hiarc4} alt="hiarc4" style={{ width: '48%', height: '36%', marginLeft : '5px' }} />
                                    <img src={hiarc5} alt="hiarc5" style={{ width: '48%', height: '36%', marginRight : '5px' }} />
                                </div>
                            )}
                            {showHiarc4 && (
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img src={hiarc6} alt="hiarc6" style={{ width: '40%', height: '52%' }} />
                                </div>
                            )}
                            {showHiarc5 && (
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                    <img src={hiarc7} alt="hiarc7" style={{ width: '48%', height: '36%' }} />
                                </div>
                            )}
                        </div>
                    </div>
                )}
                <div onClick={toggleActivityDetails3} style={{ cursor: 'pointer', paddingTop: '20px', fontSize: '20px' }}>
                    <div style={{ display:'flex', flexDirection: 'row', marginBottom: '20px' }}>
                        <div style={{ fontSize: '18px' }}>
                            🔘 &nbsp;
                        </div>
                        <div style={{ fontSize: '27px' }}>
                            ExP (2022.03 ~ 2022.12)
                        </div>
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 활동 내용 : 게임 개발 동아리의 게임 개발 팀으로 참여하여 게임 개발 및 출시 (쳐라쳐라 매우쳐라)
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 활동 내용 : 게임 개발 동아리의 기획 팀으로 참여하여 게임 개발 및 출시 (3Cards)
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 스택 : C#, Unity
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 자세히 보기 / 닫기 (클릭)
                    </div>
                </div>
                {showActivityDetails3 && (
                    <div>
                        <div style={{ paddingTop: '20px', marginLeft: '50px' }}>
                            <strong style={{ fontSize: '20px' }}> - 쳐라쳐라 매우쳐라 플레이 하기 : &nbsp;
                                <a href="https://play.google.com/store/apps/details?id=com.ExPStudio.HitItHitIt" target="_blank" rel="noopener noreferrer">
                                    https://play.google.com/store/apps/details?id=com.ExPStudio.HitItHitIt
                                </a>
                            </strong>
                            <div style={{ paddingTop: '20px', marginLeft: '50px' }}></div>
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/O8PyJGZpcdk" frameborder="0" allowfullscreen></iframe>
                        </div>
                        <div style={{ paddingTop: '20px', marginLeft: '50px' }}>
                            <strong style={{ fontSize: '20px' }}> - 3Cards 플레이 하기 : &nbsp;
                                <a href="https://play.google.com/store/apps/details?id=com.ExPstudio.threeCards&hl=ko&gl=US" target="_blank" rel="noopener noreferrer">
                                    https://play.google.com/store/apps/details?id=com.ExPstudio.threeCards&hl=ko&gl=US
                                </a>
                            </strong>
                            <div style={{ paddingTop: '20px', marginLeft: '50px' }}></div>
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/CNbowAN7FhE" frameborder="0" allowfullscreen></iframe>
                        </div>
                    </div>
                )}
            </div>
            <Element name="award"></Element>
            <div style={{ paddingTop: '120px' }}></div>
            <div className="card-face">
                <strong style={{ fontSize: '48px', marginLeft: '30px' }}>Award</strong>
                <div onClick={toggleAwardDetails1} style={{ cursor: 'pointer', paddingTop: '50px', fontSize: '20px' }}>
                    <div style={{ display:'flex', flexDirection: 'row', marginBottom: '20px' }}>
                        <div style={{ fontSize: '18px' }}>
                            🔘 &nbsp;
                        </div>
                        <div style={{ fontSize: '27px' }}>
                            홍익대학교 컴퓨터공학과 졸업 전시회 (장려상)
                        </div>
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 주최 : 홍익대학교 컴퓨터공학과
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 내용 : 졸업 프로젝트로 제작한 웹 사이트가 주제의 실용성, 결과물의 완성도를 인정받아 수상
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 자세히 보기 / 닫기 (클릭)
                    </div>
                </div>
                {showAwardDetails1 && (
                    <div style={{ paddingTop: '20px', marginLeft: '50px' }}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/2pCKwlUozqg" frameborder="0" allowfullscreen></iframe>
                    </div>
                )}
                <div onClick={toggleAwardDetails2} style={{ cursor: 'pointer', paddingTop: '20px', fontSize: '20px' }}>
                    <div style={{ display:'flex', flexDirection: 'row', marginBottom: '20px' }}>
                        <div style={{ fontSize: '18px' }}>
                            🔘 &nbsp;
                        </div>
                        <div style={{ fontSize: '27px' }}>
                            홍대 상권 홍보 공모전 (최우수상)
                        </div>
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 주최 : 서울신용보증재단과 홍익대학교 대학혁신지원사업단
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 내용 : 홍대 상권 홍보 공모전에서 우수한 콘텐츠를 제작하여 홍대 상권 활성화에 기여하여 수상
                    </div>
                    <div style={{ marginBottom: '10px', marginLeft: '30px' }}>
                        - 자세히 보기 / 닫기 (클릭)
                    </div>
                </div>
                {showAwardDetails2 && (
                    <div style={{ paddingTop: '20px', marginLeft: '50px' }}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/gGo216G8A_A" frameborder="0" allowfullscreen></iframe>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/tuqg_Cc_oOg" frameborder="0" allowfullscreen></iframe>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/V_sTjUYplu4" frameborder="0" allowfullscreen></iframe>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/1mEJX3c_iSs" frameborder="0" allowfullscreen></iframe>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/SMrRH7UHLds" frameborder="0" allowfullscreen></iframe>
                    </div>
                )}
            </div>
        </div>
    )
}

export default LandingPage;